module.exports = __webpack_public_path__ + "img/phone-call.198995d6.svg";